import {uriTransformer} from 'react-markdown';
import {determineAPIHost} from '../../lib/api';
import auth from '../../lib/auth';

export default function transformUri(src: string): string {
    if (src.startsWith('$documents/'))
        src = src.replace('$documents/', determineAPIHost() + '/v2/stream/document/') + '?token=' + auth.token;
    return uriTransformer(src);
}